import { Chip } from "@mui/material";
import AutoHelp from "../../../../../UI/Wrappers/AutoHelp";
import { EMPTY_MARK, parseRecipient } from "../../../../Actions/utils";

const TTChip = ({ data }) => {
  const { name, address } = parseRecipient(data);
  const fixedTooltip = address ? `(${address}) ${name}` : name;

  return (
    <AutoHelp {...{ fixedTooltip }}>
      <Chip label={name || EMPTY_MARK} color="primary" />
    </AutoHelp>
  );
};

export default TTChip;
